import React, { useState, useEffect } from 'react';

import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';

import ServiceOverview from 'services/serviceOverview';

export default function ComponentListItem(props) {

    const [items, setItems] = useState([]);

    const [loading, setLoading] = useState(true);

    const overviewService = new ServiceOverview();

    const loadData = () => {
        (async function () {
            if (props.range !== undefined && props.range.from !== undefined && props.range.to !== undefined) {
                let body = {
                    "startDate": props.range.from.toISOString(),
                    "endDate": props.range.to.toISOString(),
                }
                var res = await overviewService.getTopItem(body, '');
                if (res['status']) {
                    setItems(res.data);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            }
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, [props.range]);

    return (
        <div className="col-span-4 cursor-pointer">
            <div className="shadow bg-white rounded-lg p-4">
                <div className='flex items-center justify-between'>
                    <h3 className='text-lg font-sans font-medium'>Top Item | Top 10</h3>
                </div>
                <hr className='my-2' />
                {loading && <Skeleton count={10} />}
                {
                    (items.length == 0 && !loading) && <div className='text-sm text-blue-400 font-sans border border-dashed rounded p-2 mt-2'>
                        <p className='text-center'>No data found.</p>
                    </div>
                }
                <div className='space-y-2'>
                    {
                        items.map((item) => {
                            return <div className='w-full flex my-2'>
                                <img src="https://placehold.co/400" alt='Profile Image' className='w-[40px] h-[40px] rounded mr-2' />
                                <div className='flex flex-col items-start justify-start'>
                                    <h1 className='text-sm font-medium text-black'>{item.name}</h1>
                                    <p className='text-xs font-medium text-gray-600'>Qty Sale ({item.totalQty})</p>
                                </div>
                                <div className='flex-grow'></div>
                                <div className='text-sm text-green-600 font-medium'>
                                    <p>₹ {item.totalValue.toFixed(2)}</p>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}
